export const setIntervalHandler = (intervalMillis: number) => {
  let intervalId: NodeJS.Timeout | string | number | undefined;

  const setIntervalCallback = async (
    callback: any,
    shouldShowCallbackFirst = false
  ) => {
    if (typeof callback !== "function") {
      return;
    }

    if (shouldShowCallbackFirst) {
      await callback();
    }

    intervalId = setInterval(async () => {
      await callback();
    }, intervalMillis);
  };

  const clearIntervalCallback = () => {
    clearInterval(intervalId);
    intervalId = undefined;
  };

  return {
    intervalId,
    setIntervalCallback,
    clearIntervalCallback,
  };
};
